const DOWNLOAD_EXTENSIONS: Record<string, string> = {
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/webp": "webp",
  "video/mp4": "mp4",
  "video/quicktime": "mov",
  "audio/mpeg": "mp3",
  "audio/wav": "wav",
};

function extensionForMime(mime: string | null | undefined): string {
  if (!mime) return "bin";
  const normalized = mime.toLowerCase();
  const subtype = normalized.split("/")[1]?.replace(/[^a-z0-9]/g, "");
  return DOWNLOAD_EXTENSIONS[normalized] ?? (subtype || "bin");
}

export function buildDownloadFilename(
  modelKey: string,
  id: string,
  index: number,
  mime: string | null | undefined
): string {
  const safeModel = modelKey.replace(/[^a-zA-Z0-9._-]+/g, "-").replace(/^-+|-+$/g, "") || "generation";
  return `${safeModel}_${id.slice(0, 8)}_${index}.${extensionForMime(mime)}`;
}
